import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  InputValidator,
  EmailPatternValidationRule,
  MinLengthValidationRule,
  PhoneNumberValidationRule,
  NonEmptyValidationRule
} from 'core/validation';

import Field from 'core/forms/Field';

import RecaptchaField from 'common/components/fields/RecaptchaField';
import InputTextField from 'common/components/fields/InputTextField';
import PhoneNumberField from 'common/components/fields/PhoneNumberField';
import CreatableSelectField from 'common/components/fields/CreatableSelectField';

import { countriesByName, localeStrings as strings } from 'applicationConfig';

import { isUndefined } from 'utils';

import './userDetails.scss';

@observer
class UserDetailsFormInputs extends Component {
  constructor(props) {
    super(props);

    this.saveQuestion = this.saveQuestion.bind(this);
    this.saveCountry = this.saveCountry.bind(this);
  }

  saveQuestion(data) {
    this.props.formStore.onChangeFieldValue('question', (data && data.label) || '');
    this.props.formStore.onChangeFieldValue('answer', '');
  }

  saveCountry(data) {
    this.props.formStore.onChangeFieldValue('country', (data && data.country) || '');
  }

  render() {
    const emailValidator = new EmailPatternValidationRule(strings.generic.errorMessages.invalidEmail);
    const formLabels = this.props.formLabels || strings.register;

    return (
      <div className="user-details-inputs">
        <div className="field-group required-field-group">
          <label className="field-group-label">{formLabels.emailInfo}</label>

          <div className="field-group-value">
            <Field
              component={InputTextField}
              type="text"
              name="email"
              readOnly={this.props.formStore.values.readOnlyEmail}
              placeholder={strings.login.lblLogin}
            >
              <InputValidator>{[ emailValidator ]}</InputValidator>
            </Field>
          </div>
        </div>

        <div className="field-group required-field-group">
          <label className="field-group-label">{formLabels.firstName}</label>

          <div className="field-group-value">
            <Field component={InputTextField} type="text" name="firstName" placeholder={formLabels.firstName}>
              <InputValidator>{[]}</InputValidator>
            </Field>
          </div>
        </div>

        <div className="field-group required-field-group">
          <label className="field-group-label">{formLabels.lastName}</label>

          <div className="field-group-value">
            <Field component={InputTextField} type="text" name="lastName" placeholder={strings.register.lastName}>
              <InputValidator>{[]}</InputValidator>
            </Field>
          </div>
        </div>

        <div className="field-group required-field-group">
          <label className="field-group-label">{strings.register.phoneNumberLabel}</label>

          <div className="field-group-value">
            <Field
              component={PhoneNumberField}
              name="phoneNumber"
              placeholder={strings.register.phoneNumberPlaceholder}
            >
              <InputValidator>
                {[
                  new NonEmptyValidationRule(),
                  new PhoneNumberValidationRule(strings.generic.errorMessages.invalidPhoneNumber)
                ]}
              </InputValidator>
            </Field>
          </div>
        </div>

        <div className="field-group field-group">
          <label className="field-group-label">{strings.register.companyLabel}</label>

          <div className="field-group-value">
            <Field
              optional={true}
              component={InputTextField}
              type="text"
              name="company"
              placeholder={strings.register.companyPaceholder}
              maxLength={255}
            >
              <InputValidator>{[]}</InputValidator>
            </Field>
          </div>
        </div>

        <div className="field-group required-field-group">
          <label className="field-group-label">{strings.register.country}</label>

          <div className="field-group-value">
            <div className="tpi-select">
              <Field
                component={CreatableSelectField}
                onChange={this.saveCountry}
                name="country"
                options={countriesByName}
                labelKey="country"
                valueKey="country"
                value={this.props.formStore.values.country}
                allowNewOptions={false}
              />
            </div>
          </div>
        </div>

        {!isUndefined(this.props.formStore.values.question) && (
          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.register.securityQuestion}</label>
            <div className="field-group-value">
              <div className="tpi-select">
                <Field
                  component={CreatableSelectField}
                  onChange={this.saveQuestion}
                  name="question"
                  options={strings.register.sampleQuestions}
                  valueKey="label"
                  value={this.props.formStore.values.question}
                />
              </div>
            </div>
          </div>
        )}

        {!isUndefined(this.props.formStore.values.answer) && (
          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.register.securityAnswer}</label>

            <div className="field-group-value">
              <Field component={InputTextField} type="text" name="answer" placeholder={strings.register.securityAnswer}>
                <InputValidator>
                  {[ new MinLengthValidationRule(strings.generic.errorMessages.invalidSecurityAnswer, 4) ]}
                </InputValidator>
              </Field>
            </div>
          </div>
        )}

        {!isUndefined(this.props.formStore.values.captchaVerified) && (
          <div className="field-group captcha-field-group">
            <Field component={RecaptchaField} name="captchaVerified" />
          </div>
        )}

        {!isUndefined(this.props.formStore.values.captchaVerified) && (
          <div>
            <p className="required-field-comment">
              <i>{strings.register.requiredFieldComment}</i>
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default UserDetailsFormInputs;



// WEBPACK FOOTER //
// ./src/common/components/UserDetails/UserDetailsFormInputs.jsx